import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './HomeCaseStudy.scss';
import './HomeCaseStudyResponsive.scss';
import { Link } from 'react-router-dom';

import laptop from 'assets/images/common-image/laptop.png';
import tab from 'assets/images/common-image/tab.png';
import himalyan from 'assets/images/common-image/himalyan.png';
import { useSelector, useDispatch } from 'react-redux';

function HomeCaseStudy() {
	const homeContent = useSelector((state) => state.content?.home);
	const portfolioData = homeContent?.portfolioData ?? [];
	return (
		<>
			<section className="relative owlWrapArea homeCaseStudy">
				<div className="owlWrap">
					<OwlCarousel
						className="owl-theme projectSlider"
						margin={10}
						nav
						dots={false}
						items={1}
						// autoplay={true}
						smartSpeed={1200}
					>
						{portfolioData?.length > 0 && (
							<>
								{portfolioData?.map((val, i) => {
									const content = JSON.parse(val?.content);
									return (
										<div className="item" key={`portfolio-${i}`}>
											<div className="projectSliderBox relative">
												<div className="companyName">{content?.homeSection?.backgroundText}</div>
												<div className="solidBox" style={{ background: `${content?.homeSection?.color}` }}></div>

												<div className="psbBtm w-100 d-flex flex-wrap align-items-center">
													<div className="plLeft">
														<div className="imglaptop relative">
															<div className="lapTopImg">
																<img
																	src={
																		content?.homeSection?.img1 ? `${process.env.REACT_APP_RESOURCE_URL}/${content?.homeSection?.img1}` : laptop
																	}
																	alt=""
																/>
															</div>
															<div className="tabImg">
																<img
																	src={content?.homeSection?.img2 ? `${process.env.REACT_APP_RESOURCE_URL}/${content?.homeSection?.img2}` : tab}
																	alt=""
																/>
															</div>
														</div>
													</div>
													<div className="plRight relative">
														<div className="plRightInfo">
															<div className="plRightLogo">
																<img
																	src={
																		content?.mainSection?.clientLogo
																			? `${process.env.REACT_APP_RESOURCE_URL}/${content?.mainSection?.clientLogo}`
																			: himalyan
																	}
																	alt=""
																/>
															</div>
															<h6 dangerouslySetInnerHTML={{ __html: content?.mainSection?.title ?? `Lorem Ipsum is doler` }}></h6>
															<p
																dangerouslySetInnerHTML={{
																	__html:
																		content?.mainSection?.description ??
																		`Over the years we’ve designed and developed from scratch large scalable web & mobile Apps that have been featured in the
																		<br />
																		AppStore & delighted users with their experience & impact by solving real world problems for businesses and customers. We have many
																		more exciting platforms in the works, yet here’s what’s already live: 222`,
																}}
															></p>

															<ul className="d-flex w-100">
																<li>
																	<img src={''} alt="" />
																</li>
															</ul>
															<Link to={`/portfolio-details/${val?.slug}`} className="caseStudy">
																case study
															</Link>
														</div>
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</>
						)}
					</OwlCarousel>
				</div>
			</section>
			<section className="mobile-case-slider d-none">
				<div className="container-fluid p-0">
					<div className="row g-0">
						<div className="col-12">
							<div className="mobile-owl-wrap owl-arrow-box">
								<OwlCarousel className="owl-theme" margin={10} stagePadding={40} loop={true} nav={false} dots={true} items={1} smartSpeed={1200}>
									{portfolioData?.length > 0 && (
										<>
											{portfolioData?.map((val, i) => {
												const content = JSON.parse(val?.content);
												return (
													<div className="item" key={`portfolio-mobile-${i}`}>
														<div className="mobile-slider-box">
															<Link to={`/portfolio-details/${val?.slug}`} className="mobile-slider-info-box">
																<div className="image-wrap relative">
																	<div className="lapTopImg">
																		<img
																			src={
																				content?.homeSection?.img1
																					? `${process.env.REACT_APP_RESOURCE_URL}/${content?.homeSection?.img1}`
																					: laptop
																			}
																			alt=""
																		/>
																	</div>
																	<div className="tabImg">
																		<img
																			src={
																				content?.homeSection?.img2
																					? `${process.env.REACT_APP_RESOURCE_URL}/${content?.homeSection?.img2}`
																					: tab
																			}
																			alt=""
																		/>
																	</div>
																</div>
																<div className="mobile-slider-info">
																	<div className="mobile-slider-info-logo">
																		<img
																			src={
																				content?.mainSection?.clientLogo
																					? `${process.env.REACT_APP_RESOURCE_URL}/${content?.mainSection?.clientLogo}`
																					: himalyan
																			}
																			alt=""
																		/>
																	</div>
																	<span className="caseStudy">case study</span>
																</div>
															</Link>
														</div>
													</div>
												);
											})}
										</>
									)}

									{/* <div className="item">
										<div className="mobile-slider-box">
											<a href="#" className="mobile-slider-info-box">
												<div className="image-wrap relative">
													<div className="lapTopImg">
														<img src={laptop} alt="" />
													</div>
													<div className="tabImg">
														<img src={tab} alt="" />
													</div>
												</div>
												<div className="mobile-slider-info">
													<div className="mobile-slider-info-logo">
														<img src={himalyan} alt="" />
													</div>
													<span className="caseStudy">case study</span>
												</div>
											</a>
										</div>
									</div>
									<div className="item">
										<div className="mobile-slider-box">
											<a href="#" className="mobile-slider-info-box">
												<div className="image-wrap relative">
													<div className="lapTopImg">
														<img src={laptop} alt="" />
													</div>
													<div className="tabImg">
														<img src={tab} alt="" />
													</div>
												</div>
												<div className="mobile-slider-info">
													<div className="mobile-slider-info-logo">
														<img src={himalyan} alt="" />
													</div>
													<span className="caseStudy">case study</span>
												</div>
											</a>
										</div>
									</div>
									<div className="item">
										<div className="mobile-slider-box">
											<a href="#" className="mobile-slider-info-box">
												<div className="image-wrap relative">
													<div className="lapTopImg">
														<img src={laptop} alt="" />
													</div>
													<div className="tabImg">
														<img src={tab} alt="" />
													</div>
												</div>
												<div className="mobile-slider-info">
													<div className="mobile-slider-info-logo">
														<img src={himalyan} alt="" />
													</div>
													<span className="caseStudy">case study</span>
												</div>
											</a>
										</div>
									</div>
									<div className="item">
										<div className="mobile-slider-box">
											<a href="#" className="mobile-slider-info-box">
												<div className="image-wrap relative">
													<div className="lapTopImg">
														<img src={laptop} alt="" />
													</div>
													<div className="tabImg">
														<img src={tab} alt="" />
													</div>
												</div>
												<div className="mobile-slider-info">
													<div className="mobile-slider-info-logo">
														<img src={himalyan} alt="" />
													</div>
													<span className="caseStudy">case study</span>
												</div>
											</a>
										</div>
									</div> */}
								</OwlCarousel>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

export default HomeCaseStudy;
